import {
  isOnServer,
  PARTNER,
  PartnerType,
  TRIPMONEY_DOMAIN_NAME,
} from "@tm/isomorphic-utils";
import { IncomingHttpHeaders } from "http";
import { getHost } from "../getHost";

export const getPartnerOnServerSide = (
  headers: IncomingHttpHeaders
): PartnerType => {
  if (isOnServer()) {
    const host = getHost(headers);
    if (typeof host === "string") {
      if (TRIPMONEY_DOMAIN_NAME.MYPARTNER.includes(host)) {
        return PARTNER.MYPARTNER;
      } else if (TRIPMONEY_DOMAIN_NAME.MYBIZ.includes(host)) {
        return PARTNER.MYBIZ;
      } else if (TRIPMONEY_DOMAIN_NAME.GI.includes(host)) {
        return PARTNER.GI;
      } else {
        return PARTNER.MMT;
      }
    }
  }
  return PARTNER.MMT;
};
